import { observer } from 'mobx-react-lite';
import React from 'react';
import { useWorkspacePanel } from '../../panels/hooks/use-workspace-panel';
import { useEventMetadataStore } from '../event-panel-form/event-metadata';
import { CreateEventFooter } from './create-event-footer';
import { ClearedEventFooter } from './cleared-event-footer';
import { ScheduledEventFooter } from './scheduled-event-footer';
import { ActiveEventFooter } from './active-event-footer';
import { ExternalAgencyEventFooter } from './external-agency-event-footer';
import { Box } from '@cad-arc';

export const EventPanelFooter = observer(function EventPanelFooter(): React.ReactElement {
    const eventId = useWorkspacePanel().linkedEntityId;
    const eventExists = !!eventId;
    const eventMetadataStore = useEventMetadataStore();
    const isScheduledEvent = eventExists && eventMetadataStore.state.metadata?.isScheduledEvent;
    const isClearedEvent =
        eventExists && !eventMetadataStore.state.metadata?.isActive && !isScheduledEvent;
    const isExternalAgencyEvent =
        eventExists && eventMetadataStore.state.metadata?.isAgencyExternal;
    return (
        <Box w="100%" p={4} bg="surface.foreground" borderTop="sm" borderColor="border.default">
            {!eventExists ? (
                <CreateEventFooter />
            ) : isClearedEvent ? (
                <ClearedEventFooter />
            ) : isScheduledEvent ? (
                <ScheduledEventFooter />
            ) : isExternalAgencyEvent ? (
                <ExternalAgencyEventFooter />
            ) : (
                <ActiveEventFooter />
            )}
        </Box>
    );
});
